<template>
  <div class="qr-code">
    <div class="desc">您需要关注后才能发起助力</div>
    <div class="img-wrap">
      <div class="img">
        <img v-lazy="src">
      </div>
      <div class="g">golo汽修大师</div>
      <div class="c">长按识别二维码</div>
    </div>
    <div class="btn">
      <a @click="close">返回</a>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    src: {
      type: String,
      default: require('common/image/ewm.png')
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .qr-code{
    position fixed
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index 9
    text-align center
    width: 100%;
    .desc{
      font-size size(32)
      font-weight 600
      margin-top: size(100)
    }
    .img-wrap{
      width: 100%;
      margin-top: size(70)
      .img{
        width: 43.75%;
        padding-bottom: 43.75%;
        position relative
        margin: 0 auto;
        img{
          position absolute
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
      .g{
        font-size size(32)
        font-weight 600
        margin-top: size(26)
      }
      .c{
        font-size size(30)
        margin-top: size(20)
      }
    }
    .btn{
      margin-top: size(120)
      a{
        font-size size(32)
        color: $color-text-highlight
        display inline-block
        height: size(78)
        line-height size(78)
        border: 1px solid $color-text-highlight
        width: size(310)
        -webkit-border-radius: size(40)
        -moz-border-radius: size(40)
        border-radius: size(40)
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/base/activity/zhuli/qr-code.vue